import { useNavigate, useSearchParams } from 'react-router-dom';
import { isSafeReturnTo } from '../../shared/isSafeReturnTo';
import { LoginPage } from '../identity/pages/LoginPage';
import { PARTNER_LOGIN_SLIDES } from '../partner-signin/heroSlides';

/**
 * The Partner Portal's sign-in (/partner/sign-in). It is the ordinary sign-in (the same central identity, lockout and MFA; there is no separate partner password) that lands in /partner/dashboard.
 * Choosing this page grants nothing: after sign-in the portal asks the server whether this person belongs to a partner firm and shows "You do not currently have access to this portal." if not.
 * The older EPN-36 /partner-login stays as it is.
 */
export function PartnerSignInPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  return (
    <LoginPage
      heroSlides={PARTNER_LOGIN_SLIDES}
      signInHref="/partner/sign-in"
      forgotPasswordHref="/partner-forgot-password"
      signUpHref="/signup/partner"
      showPartnerSignUpLink={false}
      onLoginSuccess={() => {
        const returnTo = params.get('returnTo');
        navigate(isSafeReturnTo(returnTo) && returnTo?.startsWith('/partner/') ? returnTo : '/partner/dashboard', { replace: true });
      }}
    />
  );
}
